import { useEffect } from "react";

const SITE = "https://www.collanmoreislandlodge.com";
export const SITE_URL = SITE;
const DEFAULT_IMAGE = `${SITE}/images/og-image.jpg`;
const DEFAULT_IMAGE_ALT = "Golden-hour light over the lighthouse and islands of Clew Bay, County Mayo";

export function breadcrumb(path, name) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
      { "@type": "ListItem", position: 2, name, item: `${SITE}${path}` },
    ],
  };
}

export default function Seo({ title, description, path, image, imageAlt, jsonLd = [], noindex = false }) {
  useEffect(() => {
    document.title = title;
    const meta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    meta("name", "description", description);
    meta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    meta("property", "og:title", title);
    meta("property", "og:description", description);
    meta("property", "og:url", SITE + path);
    meta("property", "og:image", image || DEFAULT_IMAGE);
    meta("property", "og:image:alt", imageAlt || DEFAULT_IMAGE_ALT);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", SITE + path);

    const nodes = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);
    const els = nodes.map((data) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-page-schema", "true");
      el.text = JSON.stringify(data);
      document.head.appendChild(el);
      return el;
    });
    return () => els.forEach((el) => el.remove());
  }, [title, description, path, image, imageAlt, noindex, JSON.stringify(jsonLd)]);
  return null;
}